var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "xl", modalId: "modal-lv2", withBgClickEvent: "" },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "flex justify-between items-center" }, [
              _c(
                "h5",
                {
                  staticClass:
                    "font-bold text-gray-800 text-lg divide-x divide-gray-200",
                },
                [
                  _c("span", { staticClass: "pr-3 ml-2.5" }, [
                    _vm._v(_vm._s(_vm.taskName)),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("CrossIconNew", { staticClass: "h-5 w-5" })],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "tableShadow p-4 mt-4" }, [
              _c(
                "table",
                { staticClass: "data-table w-full text-sm font-outfit" },
                [
                  _c("thead", [
                    _c(
                      "tr",
                      _vm._l(_vm.headers, function (header) {
                        return _c(
                          "th",
                          {
                            key: header.text,
                            staticClass:
                              "bg-lightBlue px-3.5 py-3.5 border-b-1 border-gray-200 text-left font-medium",
                            style: { width: header.width },
                          },
                          [_vm._v(" " + _vm._s(header.text) + " ")]
                        )
                      }),
                      0
                    ),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.message, function (msg) {
                      return _c("tr", { key: msg.tracked_date }, [
                        _c(
                          "td",
                          {
                            staticClass:
                              "px-3.5 py-3.5 border-b-1 border-gray-200",
                            staticStyle: {
                              "{\n                  width": "'18%'",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  msg.tracked_date
                                    ? _vm.formatDate(msg.tracked_date)
                                    : "n/a"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass:
                              "px-3.5 py-3.5 border-b-1 border-gray-200",
                            staticStyle: {
                              "{\n                  width": "'67%'",
                            },
                          },
                          [_vm._v(" " + _vm._s(msg.notes || "n/a") + " ")]
                        ),
                        _c(
                          "td",
                          {
                            staticClass:
                              "px-3.5 py-3.5 border-b-1 border-gray-200",
                            staticStyle: {
                              "{\n                  width": "'15%'",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  typeof msg.time === "number"
                                    ? _vm.formatedcalculateTotalHours(msg.time)
                                    : "n/a"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _c("UiButton", {
              staticClass: "mr-2",
              attrs: {
                buttonText: "Back to Invoice",
                buttonClasses:
                  "px-2 pr-3.5 mr-2 pl-3.5 customHeight ml-auto mt-5",
                variant: "black",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }